// eslint-disable-next-line import/no-anonymous-default-export
export default {
  about: 'О выставке TOP3',
  appName: 'TOP3',
  data: 'Данные',
  tasks: 'Задания',
  'tasks.create_title': 'Создать новую задачу',
  'task.removed': 'Задача была удалена',
  logout: 'Выйти',
  password: 'Пароль',
  email: 'Эл. адрес',
  login: 'Авторизоваться',
  loginError: 'Электронная почта или пароль были неверными',
  pleaseWait: 'Пожалуйста, подождите...',
  loggedOut: 'Вы успешно вышли из системы!',
  monday: 'Понедельник',
  tuesday: 'Вторник',
  wednesday: 'Среда',
  thursday: 'Четверг',
  friday: 'Пятница',
  saturday: 'Суббота',
  sunday: 'Воскресенье',
  header: 'Задача',
  type: 'Тип',
  typeActivity: 'Мероприятия',
  typeBoard: 'Управление персоналом',
  typeDevelopment: 'Стратегическое развитие',
  task: 'Задача',
  plannedResult: 'Цель',
  achievedResult: 'Результат',
  rating: 'Рейтинг',
  ratingMet: 'Удовлетворительно',
  ratingNotMet: 'Неудовлетворительный',
  ratingAverage: 'В среднем',
  save: 'Сохранить',
  cancel: 'Отмена',
  date: 'Дата',
  weekday0: 'Понедельник',
  weekday1: 'Вторник',
  weekday2: 'Среда',
  weekday3: 'Четверг',
  weekday4: 'Пятница',
  weekday5: 'Суббота',
  weekday6: 'Воскресенье',
  week: 'Неделю',
  user: 'Наемный рабочий',
  'user.filter': 'Поиск сотрудника ...',
  noResults: 'Не найдено',
  comments: 'Комментарии',
  delete: 'Удалить',
  confirmTaskDelete: 'Вы действительно хотите удалить эту задачу?',
  myTasks: 'Мои задачи',
  sessionExpired: 'Сессия завершена',
  attachFile: 'Прикрепить файл',
  confirmCommentDelete: 'Вы уверены, что хотите удалить этот комментарий?',
  commentEmail: 'Комментарий отправлен по электронной почте',
  required: 'Это поле обязательно к заполнению',
  'comment.tooltip': 'Добавить комментарий',
  'groups.title': 'Группа',
  'group.title': 'Группа',
  'groups.edit_title': 'Изменить группу',
  'groups.create_title': 'Создать группу',
  'groups.delete_title': 'Удалить группу',
  'groups.id': 'Нет.',
  'groups.name': 'Имя',
  'groups.ownerId': 'Менеджер',
  'groups.changeOwner': 'Выбрать менеджера ...',
  'groups.find': 'Поиск группы ...',
  'group.members': 'Участники',
  'group.guests': 'Гости',
  'group.addMember': 'Добавить участников',
  'group.addGuest': 'Добавить гостя',
  'group.noMembers': 'Никто не добавлен',
  'group.confirmDelete': 'Вы действительно хотите удалить эту группу?',
  'users.title': 'Пользователи',
  'user.title': 'Пользователь',
  'user.profile': 'Мой профайл',
  'user.modify.title': 'Изменить пользователя',
  'users.create.tooltip': 'Создать пользователя',
  'users.delete_title': 'Удалить пользователя',
  'user.created': 'Naudotojas sukurtas',
  'user.updated': 'Naudotojas pakeistas',
  'user.removed': 'Naudotojas pašalintas',
  'users.id': 'Нет.',
  'user.name': 'Имя',
  'user.surname': 'Фамилия',
  'user.role': 'Роль',
  'user.role.ADMIN': 'Администратор',
  'user.role.USER': 'Пользователь',
  'user.role.undefined': 'Неопределенный',
  'user.email': 'Эл. адрес',
  'user.email.unique': 'Электронная почта должна быть уникальной',
  'user.username': 'Имя пользователя',
  'user.username.unique': 'Имя пользователя должно быть уникальным',
  'user.password': 'Пользовательский пароль',
  'user.members': 'Участник в группах',
  'user.guests': 'Гость в группах',
  'user.addGroup': 'Добавить группу',
  'user.noMembers': 'Никто не добавлен',
  'user.delete.confirm': 'Вы действительно хотите удалить этого пользователя?',
  'user.language.select': 'Язык',
  'user.language.EN': 'English',
  'user.language.ES': 'Ispano',
  'user.language.PL': 'Polskie',
  'user.language.RU': 'Русский',
  'user.language.LT': 'Lietuvių',
  'user.language.LV': 'Latviešu',
  'user.language.EE': 'Eesti',
  'user.view.edit': 'Redaguoti naudotoją',
  'user.role.select': 'Rolė',
  'user.save.tooltip': 'Išsaugoti naudotoją',
  'user.cancel.modify.tooltip': 'Atšaukti',
  'user.password.change.save.tooltip': 'Išsaugoti naują slaptažodį',
  'user.password.change.cancel.tooltip': 'Atšaukti',
  'user.view.change.password': 'Изменить пароль',
  'user.password.change.title': 'Смена пароля',
  'user.password.old': 'Старый пароль',
  'user.password.new1': 'Новый пароль',
  'user.password.new2': 'Повторите новый пароль',
  'user.password.change.mismatch': 'Пароли не соответствуют',
  'about.title': 'О выставке TOP3',
  'about.tagline': 'Нажимая эту кнопку, вы загрузите описание системы TOP3',
  'about.action': 'Скачать',
  'about.text': 'Мы будем ждать вопросов и наблюдений за нашей системой '
    + '<a href="mailto:pagalba@axis.lt">pagalba@axis.lt</a> .',
  'user.password.changed': 'Пароль изменен.',
  'user.password.change.failed': 'Не удалось сменить пароль',
  dashboard: 'Grafikas',
  'dashboard.generate': 'Generuoti',
  'dashboard.saveAsImage': 'Siųstis',
  'dashboard.exportToExcel': 'Exportuoti į Excel',
  'dashboard.dataZoom': 'Priartinti',
  'dashboard.dataZoomReset': 'Gražinti praeitą vaizdą',
  'dashboard.restore': 'Atstatyti pradinį vaizdą',
  'dashboard.noData': 'Nėra duomenų',
  'dashboard.data.title': 'Grafikas',
  'dashboard.data.dateFrom': 'Laikotarpis nuo (imtinai)',
  'dashboard.data.dateTo': 'Laikotarpis iki (imtinai)',
  'dashboard.data.unit': 'Matavimo vienetas',
  'dashboard.data.unit.WEIGHT': 'Svoris, t',
  'dashboard.data.unit.VOLUME': 'Tūris, m3',
  'dashboard.data.unit.VOLUME_AT_15C': 'Tūris prie 15°C, m3',
  'dashboard.data.exportToExcel': 'Excel',
  'dashboard.data.reportdate': 'Laikas',
  'dashboard.data.official': 'Buhalterija',
  'dashboard.data.fact': 'Faktinis',
  'dashboard.data.factFrom': 'Faktinis nuo',
  'dashboard.data.factTo': 'Faktinis iki',
  'dashboard.data.factPart5': 'Talpykla5',
  'dashboard.data.factPart6': 'Talpykla6',
  'dashboard.data.diff': 'Skirtumas',
  'dashboard.data.counter': 'Skaitiklis',
  'dashboard.data.counterDiff': 'Skaitiklio skirtumas',
  // product form generic
  products: 'Produktai',
  'products.title': 'Produktai',
  'product.title': 'Produktas',
  'product.delete.confirm': 'Ar tikrai norite pašalinti produktą',
  'product.updated': 'Produktas atnaujintas',
  'product.created': 'Produktas sukurtas',
  'product.filter': 'Ieškoti produkto...',
  'product.save.tooltip': 'Išsaugoti produktą',
  'product.modify.title': 'Produktas',
  'product.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'product.create.title': 'Produkto kūrimas',
  'product.cancel.create.tooltip': 'Atšaukti kūrimą',
  'product.create.tooltip': 'Kurti produktą',
  // product form specific
  'product.type': 'Produktas',
  'product.description': 'Aprašymas',
  'product.shortDescription': 'Trumpas aprašymas',
  'product.classificator': 'Klasifikatorius',
  'product.tarrifGroupCode': 'Tarifinė grupė',
  'product.materialType': 'Produkto rūšis',
  'product.name.unique': 'Produkto pavadinimas turi būti unikalus',

  // driver form generic
  drivers: 'Vairuotojai',
  'drivers.title': 'Vairuotojai',
  'driver.title': 'Vairuotojas',
  'driver.create.tooltip': 'Kurti Vairuotoją',
  'driver.updated': 'Vairuotojas atnaujintas',
  'driver.created': 'Vairuotojas sukurtas',
  'driver.removed': 'Vairuotojas pašalintas',
  'driver.filter': 'Ieškoti vairuotojo...',
  'driver.save.tooltip': 'Išsaugoti vairuotoją',
  'driver.modify.title': 'Vairuotojo redagavimas',
  'driver.create.title': 'Vairuotojo kūrimas',
  'driver.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'driver.cancel.create.tooltip': 'Atšaukti kūrimą',
  'driver.delete.confirm': 'Ar tikrai norite pašalinti vairuotoją',
  // driver form specific
  'driver.fullName': 'Vairuotojo vardas pavardė',
  'driver.adrNo': 'Vairuotojo ADR numeris',
  'driver.adrDate': 'Vairuotojo ADR galiojimo data',

  // company form generic
  companies: 'Įmonės',
  'companies.title': 'Įmonės',
  'company.title': 'Įmonė',
  'company.create.tooltip': 'Kurti Įmonę',
  'company.updated': 'Įmonė atnaujinta',
  'company.created': 'Įmonė sukurta',
  'company.removed': 'Įmonė pašalinta',
  'company.filter': 'Ieškoti įmonės ...',
  'company.save.tooltip': 'Išsaugoti įmonę',
  'company.modify.title': 'Įmonės redagavimas',
  'company.create.title': 'Įmonės kūrimas',
  'company.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'company.cancel.create.tooltip': 'Atšaukti kūrimą',
  'company.delete.confirm': 'Ar tikrai norite pašalinti įmonę ?',
  // company form specific
  'company.name': 'Pavadinimas',
  'company.address': 'Adresas',
  'company.vatCode': 'PVM kodas',
  'company.country': 'Valstybė',
  'company.companyCode': 'Įmonės kodas',
  'company.exciseWhNo': 'Akcizinio sandėlio Nr.',
  'company.additionalInformation': 'Papildoma informacija',
  'company.companyCode.unique': 'Įmonės kodas turi būti unikalus',
  'company.code.unique': 'Įmonės kodas turi būti unikalus',
  'country.select': 'Valstybė',
  'company.whClient': 'Sandėlio klientas',

  // tank form generic
  tanks: 'Talpyklos',
  'tanks.title': 'Talpyklos',
  'tank.create.tooltip': 'Sukurti talpyklą',
  'tank.updated': 'Talpykla atnaujinta',
  'tank.created': 'Talpykla sukurta',
  'tank.removed': 'Talpykla pašalinta',
  'tank.filter': 'Ieškoti talpyklos...',
  'tank.save.tooltip': 'Išsaugoti talpyklą',
  'tank.modify.title': 'Talpyklos redagavimas',
  'tank.create.title': 'Talpyklos kūrimas',
  'tank.cancel.modify.tooltip': 'Atšaukti redagavimą',
  'tank.cancel.create.tooltip': 'Atšaukti kūrimą',
  'tank.delete.confirm': 'Ar tikrai norite pašalinti talpyklą ?',
  // tank form specific
  'tank.name': 'Talpyklos pavadinimas',
  'tank.capacity.ltr': 'Talpa litrais (l)',
  'tank.capacity.kg': 'Talpa kilogramais (kg)',
  'tank.material': 'Produktas',
  'tank.name.unique': 'Talpyklos pavadinimas turi būti unikalus',
  'material.select': 'Produktas',

  // transport form generic
  transports: 'Transporto priemonės',
  'transports.title': 'Transporto priemonės',
  'transport.title': 'Transporto priemonė',
  'transport.create.tooltip': 'Kurti Transporto priemonę',
  'transport.updated': 'transporto priemonė atnaujinta',
  'transport.created': 'Transporto priemonė sukurta',
  'transport.removed': 'Transporto priemonė pašalinta',
  'transport.filter': 'Ieškoti transporto priemonės',
  'transport.save.tooltip': 'Saugoti transporto priemonę',
  'transport.edit.title': 'Transporto priemonės redagavimas',
  'transport.create.title': 'Transporto priemonės kūrimas',
  'transport.cancel.modify.tooltip': 'Atšaukti',
  'transport.delete.confirm': 'Ar tikrai norite pašalinti transporto priemonę',
  // transport form specific
  'transportType.select': 'Tipas',
  'transport.name.unique': 'Transporto priemonės numeris turi būti unikalus',
  'transports.description': 'Apibūdinimas',
  'transports.brand': 'Markė',
  'transports.model': 'Modelis',
  'transports.adrNo': 'ADR numeris',
  'transports.adrDate': 'ADR galiojimo data',
  'transports.segments': 'Segmentų talpos',
  'transports.segmentNo': 'Segmento Nr.',
  'transports.capacityLtr': 'Segmento talpa, l',
  'transport.segment.add': 'Pridėti segmentą',
  'transport.segment.remove': 'Pašalinti segmentą',
  'transport.identificationNo': 'Numeris',
};
